import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import QueryWorkitem from "../../../../../modules/@cloudpivot/flow-center/src/components/pc/components/query-condition/query-workitem.vue";
import StaffSelector from "../../../../../modules/@cloudpivot/form/src/common/components/form-staff-selector/pc/staff-selector.vue";
import ExpatHomePage from "../expats/homePage.vue";
import ExitHomePage from "../exit/homePage.vue";
// import OdHomePage from "../OD/homePage.vue";
import OdHomePage from "./odHomepage.vue";
import MobilityHomePage from '../mobility/homePage.vue';
import MyModal from "../components/modal.vue";
import { Badge, Table, Carousel, Form, Row, Col, Input, Select, DatePicker, Button, Modal, Cascader, Tree, Icon, Pagination, } from "@h3/antd-vue";
import Axios from "axios";
import unCompleteBm from "../../../src/views/workflow-center/workbenchInfo/workbenchComponents/unCompleteBm.vue";
import encryptApi from "@cloudpivot/common/src/utils/aes/index";
let supervise = class supervise extends Vue {
    constructor() {
        super(...arguments);
        this.isShowModal = false;
        //待办数量
        this.count = {};
        //Contact_infomation数据
        this.contactList = {};
        this.dataList = [];
        this.columns = [{
                title: "Template Name	",
                dataIndex: 'name',
            }, {
                title: "Action	",
                dataIndex: 'value',
                slots: { customRender: 'value' },
            }];
        this.tableDown = [{
                name: 'Template Name',
                value: ' /publicdoc/od/3. JD for FLIV&above_20220323.docx'
            }, {
                name: 'JD for FLIV&above	',
                value: '/publicdoc/od/4. JD for FLV&below_20220323.xlsx'
            }, {
                name: 'JD for FLV&below	',
                value: '/publicdoc/od/5. Org. Chart Template_20220323.pptx'
            }, {
                name: 'Org. Chart Template	',
                value: '/publicdoc/od/6. Supplementary document_Template__20220323.pptx'
            }, {
                name: 'Supplementary document_Template	',
                value: '/publicdoc/od/OD-User Manual V2.2.pdf'
            }];
    }
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem("token");
    }
    get appCode() {
        return this.$route.params.appCode;
    }
    /*
    /publicdoc/3. JD for FLIV&above_20220323.docx
/publicdoc/4. JD for FLV&below_20220323.xlsx
/publicdoc/5. Org. Chart Template_20220323.pptx
/publicdoc/6. Supplementary document_Template__20220323.pptx
/publicdoc/OD-User Manual V2.2.pdf

    */
    created() {
        this.getWorkCount();
        this.getAppList();
        this.getContactList();
    }
    showModal() {
        this.isShowModal = true;
    }
    changeModal() {
        this.isShowModal = false;
    }
    getWorkCount() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield Axios.get(`/api/runtime/workflow/get_work_count?appCode=`);
            if (res.errcode === 0) {
                this.count = res.data;
            }
        });
    }
    // 获取app列表
    getAppList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = window.location.href;
            let index = url.indexOf("/");
            // let c = url.substring(index + 2, url.length);
            let urlArr = url.substring(index + 2, url.length).split("/");
            let code = urlArr[2];
            let parmas = {
                filters: [],
                mobile: false,
                page: 0,
                queryCode: "appAlls",
                schemaCode: "appAlls",
                size: 999,
            };
            let res = yield Axios.post(`/api/runtime/query/list`, parmas);
            if (res.errcode === 0) {
                res.data.content.forEach((item) => {
                    if (code === item.data.appsCode) {
                        this.dataList.push(item);
                    }
                });
            }
        });
    }
    createList(data) {
        debugger;
        window.open(`/application/${data.appsCode}/application-list/${data.appchirdenCode}?HomePageMessage=1`, "_self");
        // window.open(
        //   `/form/detail?schemaCode=${data.appchirdenCode}&sheetCode=null&queryCode=${data.appchirdenCode}`
        // );
    }
    viewList(data) {
        debugger;
        if (data.outerChain === 'Yes') {
            window.open(data.outerChainURL);
        }
        else {
            // window.open(`/application/${data.appCode}/application-list/${data.code}?parentId=${data.parentId}&code=${data.code}&openMode&pcUrl&queryCode=`)
            window.open(`/application/${data.appsCode}/application-list/${data.appchirdenCode}`, "_self");
        }
    }
    //获取联系信息
    getContactList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = window.location.href;
            let index = url.indexOf("/");
            // let c = url.substring(index + 2, url.length);
            let urlArr = url.substring(index + 2, url.length).split("/");
            let code = urlArr[2];
            let parmas = {
                filters: [
                    {
                        propertyCode: "appsCode",
                        propertyType: 14,
                        propertyValue: code,
                        propertyValueName: "",
                    },
                ],
                mobile: false,
                page: 0,
                queryCode: "contactList",
                schemaCode: "contactList",
                size: 999,
            };
            let res = yield Axios.post("/api/runtime/query/list", parmas);
            if (res.errcode === 0) {
                res.data.content.forEach((item) => {
                    if (code === item.data.appsCode) {
                        this.contactList = item.data;
                    }
                });
            }
        });
    }
    //获取图片地址
    getDownloadUrl(refId) {
        const KEY = window.config.encrypt_totalRewards.KEY;
        const IV = window.config.encrypt_totalRewards.IV;
        let url = `${this.apiHost}/api/aliyun/download?refId=${encodeURIComponent(encryptApi.encrypt_iv(refId, KEY, IV))}`;
        if (this.token) {
            url += "&T=" + encodeURIComponent(encryptApi.encrypt_iv(this.token, KEY, IV));
        }
        return url;
    }
    closeIframeForm(type) {
        if (["draft", "shortcut", "unfinish"].includes(type)) {
            // @ts-ignore
            this.$refs.statistics.getWorkflowStatistics();
            // @ts-ignore
            this.$refs.myDraft.getList();
        }
    }
};
supervise = tslib_1.__decorate([
    Component({
        name: "supervise",
        components: {
            unCompleteBm,
            MyModal: MyModal,
            StaffSelector,
            QueryWorkitem,
            ABadge: Badge,
            ATable: Table,
            ACarousel: Carousel,
            AForm: Form,
            AFormItem: Form.Item,
            ARow: Row,
            ACol: Col,
            AInput: Input,
            AInputSearch: Input.Search,
            ASelect: Select,
            ASelectOption: Select.Option,
            ADatePicker: DatePicker,
            AButton: Button,
            AModal: Modal,
            ACascader: Cascader,
            ADirectoryTree: Tree.DirectoryTree,
            AIcon: Icon,
            APagination: Pagination,
            ExpatHomePage,
            ExitHomePage,
            MobilityHomePage,
            OdHomePage
        },
    })
], supervise);
export default supervise;
